module.exports = __webpack_public_path__ + "img/todito.bf3d12b.png";